
    (function() {
      const isProduction = import.meta.env.PROD;
      
      try {

        const params = new URLSearchParams(window.location.search);
        const gclid = params.get('gclid');
        const campaign_id = params.get('campaign_id')

        if (gclid) {
          // Solo guardar si no existe
          if (!localStorage.getItem('gclid')) {
            localStorage.setItem('gclid', gclid);
          }

          // Opcional: exponerlo a GTM
          if(isProduction){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'gclid_captured',
              gclid: gclid
            });
          }
          
        }
        if (campaign_id) {
          if (!localStorage.getItem('campaign_id')) {
            localStorage.setItem('campaign_id', campaign_id);
            
          }
        }
      } catch (e) {
        console.error('Error capturando gclid', e);
      }
    })();
